<template>
    <el-dialog
            title="添加位数"
            :visible="true"
            width="30%"
            :before-close="handleClose">
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" :inline="true">
            <el-form-item label="位数:" prop="code">
                <el-input v-model="form.code" clearable type="number"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="confirm('form')">确 定</el-button>
  </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "add-number-dialog",
        data() {
            return {
                form:{
                    code:''
                },
                rules:{
                    code:[
                        { required: true, message: '请输入位数', trigger: 'blur' }
                    ]
                }
            }
        },
        props: {
            type: {
                type: Number,
                default: 0
            },
            numberArr:{
                type:Array,
                default:[]
            }
        },
        methods: {
            confirm(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.form.code == 0){
                            this.$message.error('位数不能为0');
                            return;
                        }
                        let flag = 0;
                        for( var i = 0; i < this.numberArr.length;i++){
                            if(this.form.code == this.numberArr[i]){
                                this.$message.error('已经存在该设置位数！');
                                break;
                            }else{
                                flag++
                            }
                        }
                        if(flag == this.numberArr.length){
                            this.$emit('pushData',[this.form.code,this.type]);
                            this.$emit('handleClose');
                        }else{
                            this.$message({
                                message: '已经存在该设置位数',
                                type: 'warning'
                            });
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });

            },
            handleClose(){
                this.$emit('handleClose');
            }
        },
        created() {
            console.log(this.numberArr);
        },
    }
</script>

<style lang="scss" scoped>

</style>